import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./AddOnCourses.css";
import { API_BASE_URL } from "../config";

const AddOnCourses = () => {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const refs = useRef([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/certificates`)
      .then((res) => res.json())
      .then((data) => {
        // show only first 3 add-on courses on home
        setCourses(data.slice(0, 3));
      })
      .catch((err) =>
        console.error("Error fetching add-on courses:", err)
      );
  }, []);

  /* fade in + out on scroll */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.isIntersecting
            ? entry.target.classList.add("fade-show")
            : entry.target.classList.remove("fade-show");
        });
      },
      { threshold: 0.2 }
    );

    refs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, [courses]);

  return (
    <section className="addon-home-section">
      {/* HEADER */}
      <div
        className="addon-home-header fade-item"
        ref={(el) => (refs.current[0] = el)}
      >
        <h2>Add-On Courses</h2>
        <p>
          Advanced certification programs to extend your drone skills beyond
          core RPC training.
        </p>
      </div>

      {/* CARDS */}
      <div className="addon-home-grid">
        {courses.map((course, i) => (
          <div
            key={course._id}
            className="addon-home-card fade-item"
            ref={(el) => (refs.current[i + 1] = el)}
            style={{ transitionDelay: `${i * 120}ms` }}
          >
            <div className="addon-img-wrapper">
              <img
                src={
                  course.image
                    ? `${API_BASE_URL}${course.image}`
                    : "/service1.webp"
                }
                alt={course.name}
              />
            </div>

            <div className="addon-card-content">
              <h3>{course.name}</h3>
              <p>
                Specialized hands-on training with focused certification
                outcomes.
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* EXPLORE ALL */}
      <div
        className="addon-explore fade-item"
        ref={(el) => (refs.current[courses.length + 1] = el)}
      >
        <button onClick={() => navigate("/certificate")}>
          Explore all courses →
        </button>
      </div>
    </section>
  );
};

export default AddOnCourses;
